document.addEventListener('DOMContentLoaded', function () {
  function applyWpHeadTables() {
    var path = window.location.pathname.toLowerCase();
    var insertToken = '';
    var compatibleCode = '';

    if (path.indexOf('/products/hochvorschub-gewindefraskopf') !== -1) {
      insertToken = 'lnmu';
      compatibleCode = 'LNMU02';
    } else if (path.indexOf('/products/hochvorschub-einschraubfraskopf-kopie') !== -1) {
      insertToken = 'jdmt';
      compatibleCode = 'JDMT07';
    } else {
      return;
    }

    var root = document.querySelector('.kbrw');
    if (!root) return;

    if (path.indexOf('/products/hochvorschub-gewindefraskopf') !== -1) {
      root.querySelectorAll('.kbrw__applications .kbrw-application').forEach(function (application) {
        var label = application.querySelector('strong');
        if (!label) return;
        var applicationLabel = label.textContent.trim().toLowerCase();
        if (applicationLabel === 'hochvorschub' || applicationLabel === 'high feed' || applicationLabel === 'grande avance') {
          application.remove();
        }
      });
    }

    var table = root.querySelector('.kbrw-table');
    if (!table) return;
    var tableWrap = table.closest('.kbrw-table-wrap');
    if (!tableWrap) return;

    var lang = (document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    var text;

    if (lang === 'en') {
      text = {
        headGroup: 'Milling heads',
        headHeader: 'Milling head',
        diameter: 'Milling head Ø D',
        compatibleGroup: 'Compatible indexable inserts',
        compatibleHeader: 'Compatible insert',
        compatibleSpec: 'Compatible insert',
        insertApp: 'Indexable inserts',
        insertAppValue: 'Compatible: ' + compatibleCode,
        suitability: 'Suitability',
        unverified: 'Material group not conclusively verified'
      };
    } else if (lang === 'fr') {
      text = {
        headGroup: 'Têtes de fraisage',
        headHeader: 'Tête de fraisage',
        diameter: 'Ø tête de fraisage D',
        compatibleGroup: 'Plaquettes compatibles',
        compatibleHeader: 'Plaquette compatible',
        compatibleSpec: 'Plaquette compatible',
        insertApp: 'Plaquettes',
        insertAppValue: 'Compatible : ' + compatibleCode,
        suitability: 'Aptitude',
        unverified: 'Groupe de matière non vérifié de manière concluante'
      };
    } else {
      text = {
        headGroup: 'Fräsköpfe',
        headHeader: 'Fräskopf',
        diameter: 'Fräskopf Ø D',
        compatibleGroup: 'Passende Wendeschneidplatten',
        compatibleHeader: 'Passende Wendeschneidplatte',
        compatibleSpec: 'Passende Wendeschneidplatte',
        insertApp: 'Wendeschneidplatten',
        insertAppValue: 'Passend: ' + compatibleCode,
        suitability: 'Eignung',
        unverified: 'Werkstoffgruppe nicht eindeutig verifiziert'
      };
    }

    var materialLabels = {
      P: lang === 'fr' ? 'Acier' : lang === 'en' ? 'Steel' : 'Stahl',
      M: lang === 'fr' ? 'Acier inoxydable' : lang === 'en' ? 'Stainless steel' : 'Edelstahl',
      K: lang === 'fr' ? 'Fonte' : lang === 'en' ? 'Cast iron' : 'Gusseisen',
      S: lang === 'fr' ? 'Titane / superalliages' : lang === 'en' ? 'Titanium / superalloys' : 'Titan / Superlegierungen'
    };

    var verifiedGradeGroups = insertToken === 'lnmu' ? {
      tm550: ['P', 'M', 'K'],
      th550: ['P', 'M', 'K', 'S'],
      tw250: ['P', 'M']
    } : {};

    var processLabel = insertToken === 'lnmu'
      ? (lang === 'fr' ? 'Fraisage grande avance' : lang === 'en' ? 'High-feed milling' : 'Hochvorschubfräsen')
      : (lang === 'fr' ? 'Fraisage d’épaulement à 90°' : lang === 'en' ? '90° shoulder milling' : '90°-Schulterfräsen');

    function suitabilityForRow(row) {
      var search = (row.dataset.search || '').toLowerCase();
      var grade = Object.keys(verifiedGradeGroups).find(function (key) {
        return search.indexOf(key) !== -1;
      });
      if (!grade) return processLabel + ' · ' + text.unverified;
      var groups = verifiedGradeGroups[grade];
      return processLabel + ' · ISO ' + groups.join(' / ') + ' · ' + groups.map(function (code) {
        return materialLabels[code];
      }).join(', ');
    }

    root.querySelectorAll('.kbrw__properties .kbrw-property').forEach(function (property) {
      var value = property.querySelector('.kbrw-property__value');
      var label = property.querySelector('.kbrw-property__label');
      if (value && label && value.textContent.trim() === compatibleCode) {
        label.textContent = text.compatibleSpec;
      }
    });

    root.querySelectorAll('.kbrw__applications .kbrw-application').forEach(function (application) {
      var label = application.querySelector('strong');
      var value = application.querySelector('span');
      if (!label || !value) return;
      var current = label.textContent.trim().toLowerCase();
      if (current.indexOf('wendeschneid') !== -1 || current.indexOf('indexable insert') !== -1 || current.indexOf('plaquette') !== -1) {
        label.textContent = text.insertApp;
        value.textContent = text.insertAppValue;
      }
    });

    var headers = Array.from(table.querySelectorAll('thead th'));
    if (headers.length < 8) return;
    headers[0].textContent = text.headHeader;
    headers[0].setAttribute('data-mobile-label', text.headHeader);
    headers[1].textContent = text.diameter;
    headers[1].setAttribute('data-mobile-label', text.diameter);

    var headGroup = document.createElement('h3');
    headGroup.className = 'kbrw__heading kbrw__group-title';
    headGroup.textContent = text.headGroup;
    tableWrap.parentNode.insertBefore(headGroup, tableWrap);

    var familyTitle = '';
    var titleNode = root.querySelector('.kbrw__title');
    if (titleNode) familyTitle = titleNode.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

    function exactInsertTitle(row) {
      var search = (row.dataset.search || '').replace(/\s+/g, ' ').trim();
      var raw = search;
      if (familyTitle) {
        var familyIndex = search.lastIndexOf(familyTitle);
        if (familyIndex > 0) raw = search.slice(0, familyIndex).trim();
      }
      return raw.toUpperCase().replace(/^10X/, '10x');
    }

    var rows = Array.from(table.querySelectorAll('tbody tr[data-kbrw-row]'));
    var insertRows = rows.filter(function (row) {
      return (row.dataset.search || '').toLowerCase().indexOf(insertToken) !== -1;
    });

    rows.forEach(function (row) {
      if (insertRows.indexOf(row) !== -1) return;
      var name = row.querySelector('.kbrw-row__name');
      if (!name) return;
      var current = name.textContent.replace(/\s+/g, ' ').trim();
      if (current && current.indexOf(text.headHeader) !== 0) {
        name.textContent = text.headHeader + ' ' + current;
      }
    });

    if (!insertRows.length) return;

    var insertGroup = document.createElement('h3');
    insertGroup.className = 'kbrw__heading kbrw__group-title';
    insertGroup.textContent = text.compatibleGroup;

    var insertWrap = document.createElement('div');
    insertWrap.className = 'kbrw-table-wrap kbrw-table-wrap--inserts';
    var insertTable = document.createElement('table');
    insertTable.className = 'kbrw-table kbrw-table--inserts';
    var thead = document.createElement('thead');
    var headerRow = document.createElement('tr');

    function addHeader(label) {
      var th = document.createElement('th');
      th.textContent = label;
      th.setAttribute('data-mobile-label', label);
      headerRow.appendChild(th);
    }

    addHeader(text.compatibleHeader);
    addHeader(text.suitability);
    headerRow.appendChild(headers[5].cloneNode(true));
    headerRow.appendChild(headers[6].cloneNode(true));
    headerRow.appendChild(headers[7].cloneNode(true));
    thead.appendChild(headerRow);
    insertTable.appendChild(thead);

    var insertBody = document.createElement('tbody');
    insertRows.forEach(function (row) {
      var cells = Array.from(row.children);
      var name = row.querySelector('.kbrw-row__name');
      var sub = row.querySelector('.kbrw-row__sub');
      if (name) name.textContent = exactInsertTitle(row);
      if (sub) sub.textContent = text.compatibleHeader;

      [4, 3, 2, 1].forEach(function (index) {
        if (cells[index] && cells[index].parentNode === row) cells[index].remove();
      });

      var suitabilityCell = document.createElement('td');
      suitabilityCell.className = 'kbrw-cell--suitability';
      suitabilityCell.textContent = suitabilityForRow(row);
      var firstCell = row.children[0];
      if (firstCell && firstCell.nextSibling) {
        row.insertBefore(suitabilityCell, firstCell.nextSibling);
      } else {
        row.appendChild(suitabilityCell);
      }

      insertBody.appendChild(row);
    });

    insertTable.appendChild(insertBody);
    insertWrap.appendChild(insertTable);

    tableWrap.parentNode.insertBefore(insertGroup, tableWrap.nextSibling);
    tableWrap.parentNode.insertBefore(insertWrap, insertGroup.nextSibling);
  }

  function applyTableLabels(selector) {
    document.querySelectorAll(selector).forEach(function (table) {
      var headers = Array.from(table.querySelectorAll('thead th')).map(function (th) {
        return th.dataset.mobileLabel || th.textContent.replace(/\s+/g, ' ').trim();
      });
      table.querySelectorAll('tbody tr').forEach(function (row) {
        Array.from(row.children).forEach(function (cell, index) {
          if (cell.tagName === 'TD' && headers[index]) cell.setAttribute('data-label', headers[index]);
        });
      });
    });
  }

  applyWpHeadTables();
  applyTableLabels('.kbrw-table');
  applyTableLabels('.kcart__table');
});
